import React from "react";
import { Modal } from "react-bootstrap";
import PdfViewer from "../utilsComponent/PdfView";
import "../scss/documentPreviewModal.scss"

const DocumentPreviewModal = ({
    open,
    onClose,
    heading,
    fileUrl,
    fileType
}) => {
    return <>
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={open}
            onHide={onClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {heading}
                </Modal.Title>
                <span onClick={onClose} className="custom-close">×</span>
            </Modal.Header>
            <Modal.Body style={{ overflow: "auto" }}>

                <div >
                    {(
                        fileType === "pdf" ? (
                            <PdfViewer docUrl={fileUrl} />
                        ) : (
                            <div className="image">
                                <img src={fileUrl} width={"auto"} alt='' className='image-original-size' />
                            </div>
                        )

                    )}
                </div>
            </Modal.Body>
        </Modal>
    </>
}

export default DocumentPreviewModal
